var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"493734fcdc76f403d6e68c320e40ac8fffe6369f"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["esquire-app@chew-tzi-hwee"]={id:"493734fcdc76f403d6e68c320e40ac8fffe6369f"};
      